import { locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  JA_JP,
  EN_IN,
  IT_IT,
} = locales;

export const hasZeroAndOneAgeLabelsRule = [EN_US];
export const isChildrenMaxAgeElevenRule = [EN_IN];
export const hasChildAgeBelowTwoRule = [JA_JP];
export const hasInfantsInLapOnlyRule = [IT_IT];
